import React from 'react';
import { connect } from 'react-redux';

import { toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';

import {
  editarContrato,
  obterContratoLikePeloNumero,
  atualizarStatusLiberacaoPlanilha,
  liberarPlanilhaQuantidades,
  estornarPlanilhaQuantidades,
  cancelarContrato,
  setStatusDistBrindes,
  setStatusEnderecoPreenchido,
  setStatusPersonalizacaoLiberada,
  setStatusWeblojaLiberada,
  concluirPlanilhaCompras,
} from '../actions/ContratoActions';
import { editarUsuario } from '../actions/UsuarioActions';
import DetalhesFormando from '../components/DetalhesFormando';
import DetalhesDistribuicao from '../components/DetalhesDistribuicao';
import DetalhesDistribuicaoOrcamentista from '../components/DetalhesDistribuicaoOrcamentista';
import DetalhesModuloPagamento from '../components/DetalhesModuloPagamento';
import ModalLoginPersonalizadas from '../components/ModalLoginPersonalizadas';
import TableTodos from '../components/TableTodos';
import MapaServices from '../services/mapa';
import EmailServices from '../services/email';
import { ATENDENTES } from '../config/atendentes';
import { DistribuicaoComprasComissao } from '../components/contrato/DistribuicaoComprasComissao';

class ContratosTodos extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contrato: {
        codigoTemplate: '',
        numero: '',
        prazoFinalizacao: undefined,
        emailComissao: '',
        nomeComissao: '',
        dono: '',
        atendente: '',
        tipoContrato: '',
        telefone: '',
        dataFormatura: '',
        dataChegada: '',
        dataEntrega: '',
        idClienteMetrics: '',
        numOrcamento: '',
        contratante: '',
        statusCronograma: '',
        contatos: [],
        itens: [],
        gestor: '',
        emailGestor: '',
        idGestorMetrics: '',
        instituicao: '',
        idInstituicao: '',
        termoAprovado: 'false',
        sigla: '',
        curso: '',
        idCurso: '',
        cidade: '',
        idCidade: '',
        estado: '',
        idEstado: '',
        representante: '',
        idRepresentante: '',
        parceiro: '',
        idParceiro: '',
        pagamentoIndividual: '',
        selecionado: [],
        codigoAlbumConvite: '',
        contratoVitrine: '',
        personalizacaoLiberada: false,
        weblojaLiberada: false,
      },
      contato: {},
      pesquisa: {
        numContrato: '',
        vendedor: '',
        designer: '',
        cidade: '',
        instituicao: '',
        sigla: '',
        curso: '',
        pesquisando: false,
      },
      classInputs: {
        numero: '',
        gestor: '',
        emailComissao: '',
        telefone: '',
        numOrcamento: '',
        tipoContrato: '',
        instituicao: '',
        sigla: '',
        curso: '',
        cidade: '',
        estado: '',
        representante: '',
        parceiro: '',
        dataFormatura: '',
        dataChegada: '',
        dataEntrega: '',
        prazoFinalizacao: '',
        statusCronograma: '',
      },
      modalCorrecao: {
        show: false,
        carregando: false,
        titulo: '',
        tipo: '',
        inputCorrecao: '',
        botaoContato: '',
        dadosAlteracao: {
          nome: '',
          email: '',
          telefone: '',
          outroTelefone: '',
        },
      },
      showModalItensKit: false,
      showModalNovo: false,
      abrindoContrato: false,
      confirmarCancelamentoContrato: false,
      cancelandoContrato: false,
      kitSelecionado: null,
      precoTotalOrcamento: '',
      contratosNovos: [],
      cliente: null,
      abrirDetalhes: false,
    };
  }

  componentDidMount () {
    const params = new URLSearchParams(window.location.search);
    const contrato = params.get('contrato');
    if (contrato) {
      this.setState({ pesquisa: { ...this.state.pesquisa, numContrato: contrato } }, () => {
        this.pesquisarContrato();
      });
    }
  }

  reenviarAcesso = async () => {
    let { contrato } = this.state,
      button = document.querySelector('#btnReenviarAcesso'),
      email = new EmailServices();

    button.innerHTML =
      "<span><i class='fa fa-spinner fa-spin'></i> Enviando informações</span>";

    email
      .enviar('comissao', {
        numero: contrato.numero,
        login: { email: contrato.usuario.email, senha: contrato.usuario.senha },
        usuario: { nome: contrato.usuario.Nome, email: contrato.usuario.email },
      })
      .then((response) => {
        this.atualizarTextoBotao(response, button, {
          sucesso:
            "<i class='fa fa-check'></i> Informações enviadas com sucesso!",
          erro: "<i class='fa fa-times'></i> Falha ao enviar o e-mail com o login e a senha. Tenve novamente!",
          resetar:
            "<i class='fa fa-envelope'></i> Reenviar as informações de acesso",
        });
      });
  };

  atualizarTextoBotao = (resposta, btn, msgs) => {
    let text = '',
      color = '';

    if (resposta) {
      text = msgs.sucesso;
      color = '#00a65a';
    } else {
      text = msgs.erro;
      color = '#dd4b39';
    }

    btn.innerHTML = text;
    btn.style.color = color;
    btn.setAttribute('disabled', 'true');
    btn.closest('div').classList.add('animate__headShake');

    setTimeout(() => {
      btn.innerHTML = msgs.resetar;
      btn.removeAttribute('disabled');
      btn.style.color = '#1890ff';
      btn.closest('div').classList.remove('animate__headShake');
    }, 5000);
  };

  enviarEmail = (e) => {
    e.preventDefault();
    let email = new EmailServices(),
      button = document.querySelector(
        `#${this.state.modalCorrecao.botaoContato}`
      ),
      msgs = [],
      data = {
        usuario: { nome: 'Orçamentista' },
        numContrato: this.state.contrato.numero,
        solicitadoPor: JSON.parse(
          localStorage.getItem('usuarioLogadoAdministracao')
        ).nome,
        novosDados: {},
        dadosAntigos: {},
      };

    if (this.state.modalCorrecao.tipo === 'adicionarContato') {
      data.novosDados = this.state.modalCorrecao.dadosAlteracao;

      msgs = {
        sucesso: "<i class='fa fa-check'></i> Solicitação enviada com sucesso!",
        erro: "<i class='fa fa-times'></i> Falha ao criar a solicitação. Tenve novamente!",
        resetar: "<i class='fa fa-plus'></i> Solicitar adição de contato",
      };
    } else {
      data.dadosAntigos = this.state.modalCorrecao.dadosAlteracao;
      data.novosDados = this.state.modalCorrecao.inputCorrecao;

      msgs = {
        sucesso: "<i class='fa fa-check'></i> Correção enviada com sucesso!",
        erro: "<i class='fa fa-times'></i> Falha ao enviar a correção. Tenve novamente!",
        resetar:
          "<i class='fa fa-exclamation-triangle'></i> Solicitar correção",
      };
    }

    email.enviar(this.state.modalCorrecao.tipo, data).then((response) => {
      this.atualizarTextoBotao(response, button, msgs);
      this.resetarModalCorrecao();
    });
  };

  resetarModalCorrecao = () => {
    this.setState({
      modalCorrecao: {
        show: false,
        carregando: false,
        titulo: '',
        tipo: '',
        inputCorrecao: '',
        botaoContato: '',
        dadosAlteracao: {
          nome: '',
          email: '',
          telefone: '',
        },
      },
    });
  };

  fixDataContrato(contrato) {
    if (contrato.dataChegada !== null && contrato.dataChegada.includes('T')) {
      let data = new Date(contrato.dataChegada).toLocaleDateString('pt-BR', {
        timeZone: 'UTC',
      });
      data = data.split('T')[0].split('/').reverse().join('-');
      contrato.dataChegada = data;
    }
    if (contrato.dataChegada !== null && contrato.dataFormatura.includes('T')) {
      let data = new Date(contrato.dataFormatura).toLocaleDateString('pt-BR', {
        timeZone: 'UTC',
      });
      data = data.split('T')[0].split('/').reverse().join('-');
      contrato.dataFormatura = data;
    }
    if (contrato.dataChegada !== null && contrato.dataEntrega.includes('T')) {
      let data = new Date(contrato.dataEntrega).toLocaleDateString('pt-BR', {
        timeZone: 'UTC',
      });
      data = data.split('T')[0].split('/').reverse().join('-');
      contrato.dataEntrega = data;
    }
    if (
      contrato.prazoFinalizacao === undefined ||
      contrato.prazoFinalizacao === null ||
      contrato.prazoFinalizacao === 'Invalid Date' ||
      contrato.prazoFinalizacao.includes('1970')
    ) {
      contrato.prazoFinalizacao = undefined;
    } else {
      let data = new Date(contrato.prazoFinalizacao).toLocaleDateString(
        'pt-BR',
        { timeZone: 'UTC' }
      );
      data = data.split('T')[0].split('/').reverse().join('-');
      contrato.prazoFinalizacao = data;
    }
    return contrato;
  }

  alterarForm = (event) => {
    let contrato = this.state.contrato,
      campo = event.target.name,
      valor =
        event.target.type === 'checkbox'
          ? event.target.checked
          : event.target.value;
    contrato[campo] = valor;
    this.limparClassInputs();
    this.setState({ contrato });
  };

  limparClassInputs() {
    let inputs = Object.keys(this.state.classInputs),
      classInputs = this.state.classInputs;
    inputs.forEach((input) => {
      classInputs[input] = '';
    });
    this.setState({ classInputs });
  }

  pesquisarContrato = async () => {
    let { pesquisa } = this.state,
      novos = [],
      mapaservice = new MapaServices();
    if (
      pesquisa.vendedor ||
      pesquisa.cidade ||
      pesquisa.instituicao ||
      pesquisa.sigla ||
      pesquisa.curso ||
      pesquisa.designer
    ) {
      this.setState({
        pesquisa: { ...this.state.pesquisa, pesquisando: true },
      });
      await mapaservice
        .findContratosBy({
          vendedor: pesquisa.vendedor,
          cidade: pesquisa.cidade,
          instituicao: pesquisa.instituicao,
          sigla: pesquisa.sigla,
          curso: pesquisa.curso,
          designer: pesquisa.designer,
        })
        .then(async (response) => {
          if (response.length === 0) {
            toast.info(
              'Não encontramos nenhum contrato com este(s) filtro(s)!'
            );
            this.setState({
              contratosNovos: novos,
              pesquisa: { ...this.state.pesquisa, pesquisando: false },
            });
          } else {
            for (let i = 0; i < response.length; i++) {
              let item = {},
                orcamento = response[i];
              item = response[i];
              item.curso = orcamento.curso !== undefined ? orcamento.curso : '';
              item.representante = orcamento.Nome;
              item.parceiro =
                orcamento.NomeAgencia === null || orcamento.NomeAgencia === ''
                  ? ''
                  : orcamento.NomeAgencia;
              item.instituicao = orcamento.Instituicao;
              item.sigla = orcamento.SiglaInst;
              item.cidade = orcamento.Cidade;
              item.estado = orcamento.SiglaEstado;
              novos.push(item);
            }
            this.setState({
              contratosNovos: novos,
              pesquisa: { ...this.state.pesquisa, pesquisando: false },
            });
          }
        })
        .catch((erro) => {
          console.log(erro);
        });
    } else if (pesquisa.numContrato > 0) {
      this.setState({
        pesquisa: { ...this.state.pesquisa, pesquisando: true },
      });
      let jaMostrouUmaNotificacao = false;
      await this.props.obterContratoLikePeloNumero(pesquisa.numContrato);
      if (this.props.todos.length > 0) {
        for (let i = 0; i < this.props.todos.length; i++) {
          let item = this.props.todos[i];
          if (item.numOrcamento !== null) {
            await mapaservice
              .getTabela(item.numOrcamento, pesquisa.numContrato)
              .then(async (orcamento) => {
                item.curso =
                  orcamento.curso !== undefined ? orcamento.curso : '';
                item.representante = orcamento.Nome;
                item.parceiro =
                  orcamento.NomeAgencia === null || orcamento.NomeAgencia === ''
                    ? ''
                    : orcamento.NomeAgencia;
                item.instituicao = orcamento.Instituicao;
                item.sigla = orcamento.SiglaInst;
                item.cidade = orcamento.Cidade;
                item.estado = orcamento.SiglaEstado;
                item.contatos = orcamento.contatos;
              })
              .catch((err) => {
                if (!jaMostrouUmaNotificacao) {
                  toast.warn(
                    'Pode ser que alguns contratos não tenham todas as informações!'
                  );
                  jaMostrouUmaNotificacao = true;
                }
              });
          } else if (item !== null) {
            item.curso = '';
            item.representante = '';
            item.parceiro = '';
            item.instituicao = '';
            item.sigla = '';
            item.cidade = '';
            item.estado = '';
          }
          novos.push(item);
        }
        this.setState({
          contratosNovos: novos,
          pesquisa: { ...this.state.pesquisa, pesquisando: false },
        });
      } else {
        toast.info('Não encontramos nenhum contrato com este(s) filtro(s)!');
        this.setState({
          pesquisa: { ...this.state.pesquisa, pesquisando: false },
          contratosNovos: [],
        });
      }
    }
  };

  handleKitObs(kit) {
    let itens = this.state.contrato.itens;
    if (itens !== undefined && itens.length > 0) {
      itens.forEach((item) => {
        if (this.state.showModalNovo === 'orc') {
          if (item.nome === kit.nome) {
            if (item.obs === undefined || item.obs === 'Sim') {
              item.obs = 'Não';
            } else {
              item.obs = 'Sim';
            }
          }
        } else {
          if (item.produto === kit.produto) {
            if (item.tipo === 'Sim') {
              item.tipo = 'Não';
            } else {
              item.tipo = 'Sim';
            }
          }
        }
      });
    }
    let contrato = this.state.contrato;
    contrato.itens = itens;
    this.setState({ contrato });
  }

  configurarContrato() {
    let contrato = Object.assign({}, this.state.contrato),
      mapa = new MapaServices();
    this.limparClassInputs();
    contrato.usuario.email = contrato.emailComissao;
    contrato.usuario.login = contrato.emailComissao;
    contrato.usuario.nome = contrato.nomeComissao;
    this.props.editarUsuario(contrato.usuario, contrato.usuario.id);
    delete contrato.usuario;
    delete contrato.dono;
    this.props.editarContrato(contrato.id, contrato).then(() => {
      mapa.atualizarContratoCronograma(contrato.numero, {
        dtFormatura: contrato.dataFormatura,
        dtEntrega: contrato.dataEntrega,
      });
      this.setState({ showModalNovo: false });
    });
    this.setState({ atualizarTabelas: true });
  }

  async prepararContrato(c) {
    let mapa = new MapaServices();

    if (c.usuario) {
      await this.props.obterContratoLikePeloNumero(c.numero);
      if (this.props.todos) {
        c.usuario = this.props.todos[0].usuario;
        c.itens = this.props.todos[0].itens;
        c.dono = this.props.todos[0].dono;
        c.turmas = this.props.todos[0].turmas;
        c.endereco = this.props.todos[0].endereco;
      }
    }
    if (!c.contatos && c.numOrcamento) {
      await mapa.getContatosByOrcamento(c.numOrcamento).then((response) => {
        c.contatos = response;
      });
    }

    c = this.fixDataContrato(c);
    return c;
  }

  async abrirContrato(c) {
    this.setState({
      abrindoContrato: true,
      showModalNovo:
        this.props.usuario.autenticado.tipo === 'comum' ? 'des' : 'ate',
    });
    this.props.atualizarStatusLiberacaoPlanilha(c.confirmarPlanilha);
    let precoTotalOrcamento = 0;

    c = await this.prepararContrato(c);

    if (c.itens && c.itens.length > 0) {
      for (let i = 0; i < c.itens.length; i++) {
        precoTotalOrcamento += c.itens[i].preco * c.itens[i].quantidade;
      }
    }

    c.gestor = c.dono.nome;
    c.emailGestor = c.dono.email;
    c.idGestorMetrics = c.dono.idResponsavel;

    this.setState({
      contrato: c,
      abrindoContrato: false,
      precoTotalOrcamento: precoTotalOrcamento
        .toFixed(2)
        .toLocaleString('pt-BR'),
    });
  }

  async abrirDetalhesFormando(selecionado) {
    selecionado = await this.prepararContrato(selecionado);
    this.setState({ selecionado }, () => {
      this.refs.detalhesFormando.open();
    });
  }

  async abrirDetalhesDistribuicao(selecionado) {
    const distribuiuItens = selecionado.distribuiuItens;
    // só busca o contrato completo se ainda não tem itens/turmas
    if (!selecionado.itens || !selecionado.turmas) {
      selecionado = await this.prepararContrato(selecionado);
    }
    selecionado.distribuiuItens = distribuiuItens;
    this.setState({ selecionado }, () => {
      this.refs.detalhesDistribuicao.open();
    });
  }

  async abrirDetalhesDistribuicaoOrcamentista(selecionado) {
    selecionado = await this.prepararContrato(selecionado);
    this.setState({ selecionado }, () => {
      this.refs.detalhesDistribuicaoOrcamentista.open();
    });
  }

  async abrirDetalhesModuloPagamento(selecionado) {
    selecionado = await this.prepararContrato(selecionado);
    this.setState({ selecionado }, () => {
      this.refs.detalhesModuloPagamento.open();
    });
  }

  async abrirLoginsPersonalizada(selecionado) {
    selecionado = await this.prepararContrato(selecionado);
    this.setState({ selecionado, showModalLoginPersonalizadas: true });
  }

  atualizarContrato = (data) => {
    let { contratosNovos } = this.state;
    contratosNovos.forEach((contrato) => {
      if (contrato.id === data.id) {
        contrato.turmas = data.turmas;
        data.cadastrouFormandos !== undefined
          ? (contrato.cadastrouFormandos = data.cadastrouFormandos)
          : null;
        data.distribuiuItens !== undefined
          ? (contrato.distribuiuItens = data.distribuiuItens)
          : null;
        data.sistemaPagto !== undefined
          ? (contrato.sistemaPagto = data.sistemaPagto)
          : null;
        data.avulsosLiberados !== undefined
          ? (contrato.avulsosLiberados = data.avulsosLiberados)
          : null;
        data.parcelamentoNoBoleto !== undefined
          ? (contrato.parcelamentoNoBoleto = data.parcelamentoNoBoleto)
          : null;
        data.dataMaximaPagto !== undefined
          ? (contrato.dataMaximaPagto = data.dataMaximaPagto)
          : null;
      }
    });
    this.setState({ contratosNovos });
  };

  async liberarAprovacaoPlanilha() {
    await this.props.liberarPlanilhaQuantidades(
      this.state.contrato,
      !this.props.confirmarPlanilha
    );
    let contrato = this.state.contrato;
    contrato.confirmarPlanilha = this.props.planilhaComprasDistribuida;
    this.setState({ contrato: contrato });
  }

  async concluirPlanilhaCompras() {
    await this.props.concluirPlanilhaCompras(
      this.state.contrato,
      !this.props.distribuiuItens
    );
    let contrato = this.state.contrato;
    contrato.distribuiuItens = this.props.distribuiuItens;
    this.setState({ contrato: contrato });
  }

  async setStatusDistBrindes() {
    await this.props.setStatusDistBrindes(
      this.state.contrato.id,
      !this.state.contrato.distribuiuBrindes
    );
    let contrato = this.state.contrato;
    let contratosTemp = this.props.todos;
    for (let i = 0; i < contratosTemp.length; i++) {
      if (contratosTemp[i].id === contrato.id) {
        contrato.distribuiuBrindes = contratosTemp[i].distribuiuBrindes;
        break;
      }
    }
    this.setState({ contrato: contrato });
  }

  async setStatusEndPreenchido() {
    await this.props.setStatusEnderecoPreenchido(
      this.state.contrato.id,
      !this.state.contrato.enderecoPreenchido
    );
    let contrato = this.state.contrato;
    let contratosTemp = this.props.todos;
    for (let i = 0; i < contratosTemp.length; i++) {
      if (contratosTemp[i].id === contrato.id) {
        contrato.enderecoPreenchido = contratosTemp[i].enderecoPreenchido;
        break;
      }
    }
    this.setState({ contrato: contrato });
  }

  async setStatusPersonalizacao() {
    await this.props.setStatusPersonalizacaoLiberada(
      this.state.contrato.id,
      !this.state.contrato.personalizacaoLiberada
    );
    let contrato = this.state.contrato;
    let contratosTemp = this.props.todos;
    for (let i = 0; i < contratosTemp.length; i++) {
      if (contratosTemp[i].id === contrato.id) {
        contrato.personalizacaoLiberada = contratosTemp[i].personalizacaoLiberada;
        break;
      }
    }
    this.setState({ contrato: contrato });
  }

  async setStatusWebloja() {
    await this.props.setStatusWeblojaLiberada(
      this.state.contrato.id,
      !this.state.contrato.weblojaLiberada
    );
    let contrato = this.state.contrato;
    let contratosTemp = this.props.todos;
    for (let i = 0; i < contratosTemp.length; i++) {
      if (contratosTemp[i].id === contrato.id) {
        contrato.weblojaLiberada = contratosTemp[i].weblojaLiberada;
        break;
      }
    }
    this.setState({ contrato: contrato });
  }

  async estornarPlanilhaQtdes() {
    let button = document.querySelector('#btnEstornarPlanilha');
    button.innerHTML =
      "<span><i class='fa fa-spinner fa-spin'></i> Estornando</span>";

    await this.props.estornarPlanilhaQuantidades(this.state.contrato.id);
    let contrato = this.state.contrato;
    let contratosTemp = this.props.todos;
    for (let i = 0; i < contratosTemp.length; i++) {
      if (contratosTemp[i].id === contrato.id) {
        contrato.distribuiuItens = contratosTemp[i].distribuiuItens;
        contrato.dtAprPlanilha = contratosTemp[i].dtAprPlanilha;
        break;
      }
    }

    if (contrato.dtAprPlanilha !== null) {
      button.innerHTML =
        "<i class='fa fa-undo'></i> Estornar planilha de quantidades";
      alert(
        'Erro ao estornar a planilha de quantidades. Por favor, tente novamente!'
      );
    }

    this.setState({ contrato: contrato });
  }

  async estornarPlanilhaCompras() {
    let button = document.querySelector('#btnEstornarPlanilha');
    button.innerHTML =
      "<span><i class='fa fa-spinner fa-spin'></i> Estornando</span>";

    await this.props.concluirPlanilhaCompras(this.state.contrato.id, false);
    let contrato = this.state.contrato;
    let contratosTemp = this.props.todos;
    for (let i = 0; i < contratosTemp.length; i++) {
      if (contratosTemp[i].id === contrato.id) {
        contrato.distribuiuItens = contratosTemp[i].distribuiuItens;
        contrato.dtAprPlanilha = contratosTemp[i].dtAprPlanilha;
        break;
      }
    }

    if (contrato.dtAprPlanilha !== null) {
      button.innerHTML =
        "<i class='fa fa-undo'></i> Estornar planilha de quantidades";
      alert(
        'Erro ao estornar a planilha de quantidades. Por favor, tente novamente!'
      );
    }

    this.setState({ contrato: contrato });
  }

  async cancelarContrato() {
    this.setState({ cancelandoContrato: true });
    const cancelado = await this.props.cancelarContrato(this.state.contrato.id);

    if (cancelado) {
      alert(`Contrato ${this.state.contrato.numero} cancelado!`);
      this.setState({
        showModalNovo: false,
        confirmarCancelamentoContrato: false,
      });
      this.pesquisarContrato();
    } else {
      alert(
        `Não foi possível cancelar o contrato ${this.state.contrato.numero}. Tente novamente mais tarde!`
      );
    }
    this.setState({ cancelandoContrato: false });
  }

  _renderFormContrato() {
    return (
      <div>
        <form onChange={this.alterarForm}>
          <div className='row'>
            <div
              className={`form-group col-sm-12 col-md-3 ${this.state.classInputs.numero}`}
            >
              <label htmlFor='numero'>Contrato:</label>
              <input
                type='number'
                className='form-control'
                name='numero'
                value={this.state.contrato.numero}
                disabled
              />
            </div>
            <div
              className={`form-group col-sm-12 col-md-3 ${this.state.classInputs.numOrcamento}`}
            >
              <label htmlFor='proposta'>Proposta:</label>
              <input
                type='number'
                className='form-control'
                name='proposta'
                value={this.state.contrato.numOrcamento}
                disabled
              />
            </div>
            <div
              className={`form-group col-sm-12 col-md-3 ${this.state.classInputs.gestor}`}
            >
              <label htmlFor='gestor'>Designer(a):</label>
              <input
                type='text'
                className='form-control'
                name='gestor'
                value={this.state.contrato.gestor}
                disabled
              />
            </div>
            <div className='form-group col-sm-12 col-md-3'>
              <label htmlFor='atendente'>Atendente:</label>
              <select
                className='form-control'
                name='atendente'
                value={this.state.contrato.atendente || ''}
                disabled={this.state.showModalNovo === 'des'}
              >
                <option value=''>Selecione</option>
                {Object.keys(ATENDENTES).map((chave) => (
                  <option key={chave} value={chave}>
                    {ATENDENTES[chave]}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className='row'>
            <div
              className={`form-group col-sm-12 col-md-8 ${this.state.classInputs.emailComissao}`}
            >
              <label htmlFor='email'>E-mail principal:</label>
              <input
                type='email'
                value={this.state.contrato.emailComissao}
                disabled={this.props.usuario.autenticado.tipo !== 'orc'}
                className='form-control'
                name='emailComissao'
                required
              />
              <div className='animate__animated animate__repeat-3	3'>
                <a
                  style={{ color: '#1890ff', cursor: 'pointer' }}
                  onClick={this.reenviarAcesso}
                  id='btnReenviarAcesso'
                >
                  <i className='fa fa-envelope'></i> Reenviar informações de
                  acesso
                </a>
              </div>
            </div>
            <div
              className={`form-group col-sm-12 col-md-4 ${this.state.classInputs.telefone}`}
            >
              <label htmlFor='telefone'>Telefone principal:</label>
              <input
                type='text'
                value={this.state.contrato.telefone}
                disabled
                className='form-control'
                name='telefone'
                required
              />
            </div>
          </div>
          <div className='row'>
            {this.state.contrato.contatos &&
            this.state.contrato.contatos.length > 0 ? (
              <div className='form-group col-xs-12 col-sm-12'>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <label>Contatos:</label>
                  <div className='animate__animated animate__repeat-3	3'>
                    <a
                      id='solicitarContato'
                      onClick={() =>
                        this.setState({
                          modalCorrecao: {
                            show: true,
                            titulo: 'Adição de contato',
                            tipo: 'adicionarContato',
                            botaoContato: 'solicitarContato',
                            dadosAlteracao: {
                              nome: '',
                              email: '',
                              telefone: '',
                            },
                          },
                        })
                      }
                    >
                      <i
                        style={{ color: '#1890ff', cursor: 'pointer' }}
                        className='fa fa-plus'
                      />{' '}
                      Solicitar adição de contato
                    </a>
                  </div>
                </div>
                <div className='table-responsive'>
                  <table className='table table-bordered table-striped'>
                    <thead>
                      <tr>
                        <th>Nome</th>
                        <th>E-mail</th>
                        <th>Data de Nascimento</th>
                        <th>Telefone 1</th>
                        <th>Telefone 2</th>
                        <th>Principal</th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.contrato.contatos.map((contato, i) => (
                        <tr key={i}>
                          <td>{contato.Nome}</td>
                          <td>{contato.email}</td>
                          <td>{contato.dataNascimento ? contato.dataNascimento : ""}</td>
                          <td>{contato.Celular}</td>
                          <td>{contato.outroTelefone}</td>
                          <td>
                            {contato.ContatoPrinc === 'SIM' ? 'SIM' : 'NÃO'}
                          </td>
                          <td>
                            <div className='animate__animated animate__repeat-3	3'>
                              <a
                                id={`alteracaoContato${i}`}
                                onClick={() =>
                                  this.setState({
                                    modalCorrecao: {
                                      show: true,
                                      titulo: 'Alteração de contato',
                                      tipo: 'alterarDadosContato',
                                      botaoContato: `alteracaoContato${i}`,
                                      dadosAlteracao: {
                                        nome: contato.Nome,
                                        email: contato.email,
                                        telefone: contato.Celular,
                                      },
                                    },
                                  })
                                }
                              >
                                <i
                                  style={{
                                    color: '#1890ff',
                                    cursor: 'pointer',
                                  }}
                                  className='fa fa-exclamation-triangle'
                                />{' '}
                                Solicitar correção
                              </a>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div className='form-group col-xs-12 col-sm-12'>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <label>Contatos:</label>
                </div>
                <p style={{ marginBottom: 0 }}>
                  Vincule o este contrato a uma proposta para visualizar os
                  contatos!
                </p>
              </div>
            )}
          </div>
          <div className='row'>
            <div className='form-group col-xs-12'>
              <label>Itens contratados:</label>
              {this.state.contrato.itens &&
              this.state.contrato.itens.length > 0 ? (
                <div className='table-responsive'>
                  <table className='table table-bordered table-striped'>
                    <thead>
                      <tr>
                        <th>Item</th>
                        <th>Quantidade</th>
                        {this.state.showModalNovo !== 'des' ? (
                          <th>Preço</th>
                        ) : null}
                        <th>Tipo</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.contrato.itens.map((kit, i) => (
                        <tr key={i}>
                          <td
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                            }}
                          >
                            {kit.produto}
                            {kit.observacao === 'kit' ? (
                              <i
                                title='Clique para ver mais informações'
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                  this.setState({
                                    showModalItensKit: true,
                                    kitSelecionado: kit,
                                  });
                                }}
                                className='fa fa-info'
                              />
                            ) : null}
                          </td>
                          <td>{kit.quantidade}</td>
                          {this.state.showModalNovo !== 'des' ? (
                            <td>
                              {'R$ ' +
                                (kit.preco === null ? 0 : kit.preco)
                                  .toFixed(2)
                                  .toLocaleString('pt-BR')}
                            </td>
                          ) : null}
                          <td>{kit.observacao}</td>
                        </tr>
                      ))}
                      {this.state.showModalNovo !== 'des' ? (
                        <tr>
                          <td colSpan={3} style={{ textAlign: 'right' }}>
                            <strong>PREÇO TOTAL</strong>
                          </td>
                          <td>
                            {'R$ ' +
                              (this.state.precoTotalOrcamento === ''
                                ? '0,00'
                                : this.state.precoTotalOrcamento)}
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p style={{ marginBottom: 0 }}>
                  Vincule o este contrato a uma proposta para visualizar os
                  itens contratados!
                </p>
              )}
            </div>
          </div>
          <div className='row'>
            <div
              className={`form-group col-xs-12 col-md-4 ${this.state.classInputs.statusCronograma}`}
            >
              <label htmlFor='statusCronograma'>Status:</label>
              <select
                className='form-control'
                value={this.state.contrato.statusCronograma}
                name='statusCronograma'
                disabled={this.state.showModalNovo === 'des'}
                onChange={(e) => {
                  this.setState({
                    contrato: {
                      ...this.state.contrato,
                      statusCronograma: e.target.value,
                    },
                  });
                }}
                required
              >
                <option value=''>Selecione</option>
                <option value='Ativo'>Ativo</option>
                <option value='Inativo'>Inativo</option>
                <option value='Stand by'>Stand by</option>
              </select>
            </div>
            <div className={'form-group checkbox col-xs-12 col-md-4'}>
              <label>
                <input
                  type='checkbox'
                  checked={this.state.contrato.contratoVitrine}
                  disabled={this.state.showModalNovo === 'des'}
                  onChange={(e) => {
                    this.setState({ contrato_vitrine: e.target.checked });
                  }}
                  name='contratoVitrine'
                />
                Contrato vitrine
              </label>
              <br />
              {this.props.usuario.autenticado.tipo === 'administrador' ||
              this.props.usuario.autenticado.tipo === 'orc' ? (
                <div className='animate__animated animate__repeat-3	3'>
                  <a
                    style={{
                      color: '#1890ff',
                      cursor: 'pointer',
                      marginTop: '10px',
                    }}
                    onClick={() => {
                      this.setState({ confirmarCancelamentoContrato: true });
                    }}
                    id='btnCancelarContrato'
                  >
                    <i class='fa fa-trash'></i> Cancelar contrato
                  </a>
                </div>
              ) : (
                ''
              )}
            </div>
            <div className='col-xs-12'>
              {this.state.contrato.dtAprPlanilha == null &&
              this.props.usuario.autenticado.tipo === 'administrador' ? (
                <div className='switch' style={{ marginRight: '10px' }}>
                  <input
                    type='checkbox'
                    defaultChecked={this.props.confirmarPlanilha}
                    onClick={this.liberarAprovacaoPlanilha.bind(this)}
                    id='switch2'
                    className='switch__input'
                  ></input>
                  <label
                    htmlFor='switch2'
                    className='switch__label'
                    style={{ fontWeight: 400 }}
                  >
                    {' '}
                    Confirmar planilha de quantidades
                  </label>
                </div>
              ) : (
                <div
                  className={'form-group checkbox col-xs-12 col-md-4'}
                  style={{ marginRight: '10px' }}
                >
                  <div>
                    <i
                      style={{ color: '#00a65a' }}
                      className='fa fa-check-circle'
                    ></i>{' '}
                    Planilha de quantidades confirmada!
                  </div>
                  <div className='animate__animated animate__repeat-3	3'>
                    <a
                      style={{ color: '#1890ff', cursor: 'pointer' }}
                      onClick={this.estornarPlanilhaQtdes.bind(this)}
                      id='btnEstornarPlanilha'
                    >
                      <i class='fa fa-undo'></i> Estornar planilha de
                      quantidades
                    </a>
                  </div>
                </div>
              )}

              <div className='switch' style={{ marginRight: '10px' }}>
                <input
                  type='checkbox'
                  checked={this.state.contrato.distribuiuBrindes}
                  onClick={this.setStatusDistBrindes.bind(this)}
                  id='switchStatusDistBrindes'
                  className='switch__input'
                ></input>
                <label
                  htmlFor='switchStatusDistBrindes'
                  className='switch__label'
                  style={{ fontWeight: 400 }}
                >
                  {' '}
                  Brindes {this.state.contrato.distribuiuBrindes
                    ? ''
                    : 'não '}{' '}
                  distribuídos
                </label>
              </div>

              <div className='switch' style={{ marginRight: '10px' }}>
                <input
                  type='checkbox'
                  checked={this.state.contrato.enderecoPreenchido}
                  onClick={this.setStatusEndPreenchido.bind(this)}
                  id='switchStatusEndEntrega'
                  className='switch__input'
                ></input>
                <label
                  htmlFor='switchStatusEndEntrega'
                  className='switch__label'
                  style={{ fontWeight: 400 }}
                >
                  {' '}
                  Endereço de entrega{' '}
                  {this.state.contrato.enderecoPreenchido ? '' : 'não '}{' '}
                  preenchido
                </label>
              </div>

              <div className='switch' style={{ marginRight: '10px' }}>
                <input
                  type='checkbox'
                  checked={Boolean(this.state.contrato.personalizacaoLiberada)}
                  onClick={this.setStatusPersonalizacao.bind(this)}
                  id='switchStatusPersonalizacao'
                  className='switch__input'
                ></input>
                <label
                  htmlFor='switchStatusPersonalizacao'
                  className='switch__label'
                  style={{ fontWeight: 400 }}
                >
                  {' '}
                  Personalização dos Convites
                </label>
              </div>

              <div className='switch' style={{ marginRight: '10px' }}>
                <input
                  type='checkbox'
                  checked={Boolean(this.state.contrato.weblojaLiberada)}
                  onClick={this.setStatusWebloja.bind(this)}
                  id='switchStatusWebloja'
                  className='switch__input'
                ></input>
                <label
                  htmlFor='switchStatusWebloja'
                  className='switch__label'
                  style={{ fontWeight: 400 }}
                >
                  {' '}
                  Liberar Webloja
                </label>
              </div>

              {this.props.usuario.autenticado.tipo === 'administrador' ||
              this.props.usuario.autenticado.tipo === 'orc' ? (
                <DistribuicaoComprasComissao
                  contratoID={this.state.contrato.id}
                />
              ) : null}
            </div>
          </div>
          <div className='row'>
            <div
              className={`form-group col-xs-12 col-md-8 ${this.state.classInputs.instituicao}`}
            >
              <label htmlFor='instituicao'>Instituição:</label>
              <input
                type='text'
                disabled
                value={this.state.contrato.instituicao}
                className='form-control'
                name='instituicao'
                required
              />
            </div>
            <div
              className={`form-group col-xs-12 col-md-4 ${this.state.classInputs.sigla}`}
            >
              <label htmlFor='sigla'>Sigla:</label>
              <input
                type='text'
                disabled
                value={this.state.contrato.sigla}
                className='form-control'
                name='sigla'
                required
              />
            </div>
          </div>
          <div className='row'>
            <div
              className={`form-group col-xs-12 ${this.state.classInputs.curso}`}
            >
              <label htmlFor='curso'>Curso:</label>
              {this.state.contrato.turmas &&
              this.state.contrato.turmas.length > 0 ? (
                <div
                  style={{
                    width: '100%',
                    overflowX: 'auto',
                    display: 'flex',
                    backgroundColor: '#eee',
                    border: '1px solid #d2d6de',
                    padding: '6px 12px 6px 10px',
                    cursor: 'not-allowed',
                  }}
                >
                  {this.state.contrato.turmas.map((turma, i) => (
                    <div
                      key={i}
                      style={{
                        backgroundColor: '#ccc',
                        marginRight: 5,
                        padding: '0px 10px',
                        borderRadius: 15,
                      }}
                    >
                      {turma.curso}
                    </div>
                  ))}
                </div>
              ) : (
                <input
                  type='text'
                  value={this.state.contrato.curso}
                  className='form-control'
                  name='curso'
                  disabled
                  required
                />
              )}
            </div>
          </div>
          <div className='row'>
            <div
              className={`form-group col-xs-8 ${this.state.classInputs.cidade}`}
            >
              <label htmlFor='cidade'>Cidade:</label>
              <input
                type='text'
                readOnly
                value={this.state.contrato.cidade}
                className='form-control'
                name='cidade'
                required
              />
            </div>
            <div
              className={`form-group col-xs-4 ${this.state.classInputs.estado}`}
            >
              <label htmlFor='estado'>Estado:</label>
              <input
                type='text'
                readOnly
                value={this.state.contrato.estado}
                className='form-control'
                name='estado'
                required
              />
            </div>
          </div>
          <div className='row'>
            <div
              className={`form-group col-sm-6 ${this.state.classInputs.representante}`}
            >
              <label htmlFor='representante'>Representante:</label>
              <input
                type='text'
                disabled
                value={this.state.contrato.representante}
                className='form-control'
                name='representante'
                required
              />
            </div>
            <div
              className={`form-group col-sm-6 ${this.state.classInputs.parceiro}`}
            >
              <label htmlFor='parceiro'>Parceiro:</label>
              <input
                type='text'
                disabled
                value={
                  this.state.contrato.parceiro
                    ? this.state.contrato.parceiro
                    : 'Não possui'
                }
                className='form-control'
                name='parceiro'
                required
              />
            </div>
          </div>
          <div className='row'>
            <div
              className={`col-xs-12 col-sm-6 col-md-3 ${this.state.classInputs.dataFormatura}`}
            >
              <label htmlFor='dataFormatura'>Data da Formatura:</label>
              <input
                type='date'
                value={this.state.contrato.dataFormatura}
                disabled={this.state.showModalNovo === 'des'}
                className='form-control'
                name='dataFormatura'
                onChange={(e) => {
                  this.setState({
                    contrato: {
                      ...this.state.contrato,
                      dataFormatura: e.target.value,
                    },
                  });
                }}
                required
              />
            </div>
            <div
              className={`col-xs-12 col-sm-6 col-md-3 ${this.state.classInputs.dataEntrega}`}
            >
              <label htmlFor='dataEntrega'>Data da Entrega:</label>
              <input
                type='date'
                value={this.state.contrato.dataEntrega}
                disabled={this.state.showModalNovo === 'des'}
                className='form-control'
                name='dataEntrega'
                onChange={(e) => {
                  this.setState({
                    contrato: {
                      ...this.state.contrato,
                      dataEntrega: e.target.value,
                    },
                  });
                }}
                required
              />
            </div>
            <div
              className={`col-xs-12 col-sm-6 col-md-3 ${this.state.classInputs.dataChegada}`}
            >
              <label htmlFor='dataChegada'>Data da Chegada:</label>
              <input
                type='date'
                value={this.state.contrato.dataChegada}
                className='form-control'
                name='dataChegada'
                disabled
                required
              />
            </div>
            <div
              className={`col-xs-12 col-sm-6 col-md-3 ${this.state.classInputs.prazoFinalizacao}`}
            >
              <label htmlFor='prazoFinalizacao'>Prazo de Finalização:</label>
              <input
                type='date'
                value={this.state.contrato.prazoFinalizacao}
                className='form-control'
                name='prazoFinalizacao'
                disabled
                required
              />
            </div>
          </div>

          <div className='row'>
            <input
              style={{ marginTop: 50, marginRight: 15 }}
              type='button'
              onClick={this.configurarContrato.bind(this)}
              className='btn btn-success flat pull-right btn-lg'
              value='Salvar alterações'
            />
          </div>
        </form>
      </div>
    );
  }

  render() {
    return (
      <div>
        <section>
          <div className='box'>
            <div className='box-body' style={{ padding: 10 }}>
              <div className='row'>
                <div className='col-sm-6 col-md-1'>
                  <label htmlFor='numContrato'>Contrato</label>
                  <input
                    type='text'
                    className='form-control'
                    id='numContrato'
                    name='numContrato'
                    value={this.state.pesquisa.numContrato}
                    onKeyPress={(e) => {
                      e.key === 'Enter' ? this.pesquisarContrato() : null;
                    }}
                    onChange={(e) => {
                      this.setState({
                        pesquisa: {
                          ...this.state.pesquisa,
                          numContrato: e.target.value,
                        },
                      });
                    }}
                  />
                </div>
                <div className='col-sm-6 col-md-2'>
                  <label htmlFor='vendedor'>Vendedor</label>
                  <input
                    type='text'
                    className='form-control'
                    id='vendedor'
                    name='vendedor'
                    value={this.state.pesquisa.vendedor}
                    onKeyPress={(e) => {
                      e.key === 'Enter' ? this.pesquisarContrato() : null;
                    }}
                    onChange={(e) => {
                      this.setState({
                        pesquisa: {
                          ...this.state.pesquisa,
                          vendedor: e.target.value,
                        },
                      });
                    }}
                  />
                </div>
                <div className='col-sm-6 col-md-2'>
                  <label htmlFor='designer'>Designer</label>
                  <input
                    type='text'
                    className='form-control'
                    id='designer'
                    name='designer'
                    value={this.state.pesquisa.designer}
                    onKeyPress={(e) => {
                      e.key === 'Enter' ? this.pesquisarContrato() : null;
                    }}
                    onChange={(e) => {
                      this.setState({
                        pesquisa: {
                          ...this.state.pesquisa,
                          designer: e.target.value,
                        },
                      });
                    }}
                  />
                </div>
                <div className='col-sm-6 col-md-2'>
                  <label htmlFor='cidade'>Cidade</label>
                  <input
                    type='text'
                    className='form-control'
                    id='cidade'
                    name='cidade'
                    value={this.state.pesquisa.cidade}
                    onKeyPress={(e) => {
                      e.key === 'Enter' ? this.pesquisarContrato() : null;
                    }}
                    onChange={(e) => {
                      this.setState({
                        pesquisa: {
                          ...this.state.pesquisa,
                          cidade: e.target.value,
                        },
                      });
                    }}
                  />
                </div>
                <div className='col-sm-6 col-md-2'>
                  <label htmlFor='instituicao'>Instituição</label>
                  <input
                    type='text'
                    className='form-control'
                    id='instituicao'
                    name='instituicao'
                    value={this.state.pesquisa.instituicao}
                    onKeyPress={(e) => {
                      e.key === 'Enter' ? this.pesquisarContrato() : null;
                    }}
                    onChange={(e) => {
                      this.setState({
                        pesquisa: {
                          ...this.state.pesquisa,
                          instituicao: e.target.value,
                        },
                      });
                    }}
                  />
                </div>
                <div className='col-sm-6 col-md-1'>
                  <label htmlFor='sigla'>Sigla</label>
                  <input
                    type='text'
                    className='form-control'
                    id='sigla'
                    name='sigla'
                    value={this.state.pesquisa.sigla}
                    onKeyPress={(e) => {
                      e.key === 'Enter' ? this.pesquisarContrato() : null;
                    }}
                    onChange={(e) => {
                      this.setState({
                        pesquisa: {
                          ...this.state.pesquisa,
                          sigla: e.target.value,
                        },
                      });
                    }}
                  />
                </div>
                <div className='col-sm-6 col-md-2'>
                  <label htmlFor='curso'>Curso</label>
                  <input
                    type='text'
                    className='form-control'
                    id='curso'
                    name='curso'
                    value={this.state.pesquisa.curso}
                    onKeyPress={(e) => {
                      e.key === 'Enter' ? this.pesquisarContrato() : null;
                    }}
                    onChange={(e) => {
                      this.setState({
                        pesquisa: {
                          ...this.state.pesquisa,
                          curso: e.target.value,
                        },
                      });
                    }}
                  />
                </div>
              </div>
              <div className='row'>
                {this.state.pesquisa.pesquisando ? (
                  <div
                    style={{
                      textAlign: 'center',
                      width: '100%',
                      marginTop: 50,
                      marginBottom: 20,
                    }}
                  >
                    <i className='fa fa-spinner fa-pulse fa-2x' />
                  </div>
                ) : this.state.contratosNovos.length > 0 ? (
                  <div className='col-xs-12' style={{ marginTop: 30 }}>
                    <TableTodos
                      usuarioLogado={this.props.usuario.autenticado}
                      contratos={this.state.contratosNovos}
                      onSelectChange={(selecionado) => {
                        this.abrirContrato(selecionado);
                      }}
                      abrirDetalhesFormando={(selecionado) => {
                        this.abrirDetalhesFormando(selecionado);
                      }}
                      abrirDetalhesDistribuicao={(selecionado) => {
                        this.abrirDetalhesDistribuicao(selecionado);
                      }}
                      abrirLoginsPersonalizada={(selecionado) => {
                        this.abrirLoginsPersonalizada(selecionado);
                      }}
                      abrirDetalhesDistribuicaoOrcamentista={(selecionado) => {
                        this.abrirDetalhesDistribuicaoOrcamentista(selecionado);
                      }}
                      abrirDetalhesModuloPagamento={(selecionado) => {
                        this.abrirDetalhesModuloPagamento(selecionado);
                      }}
                    />
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          <DetalhesFormando
            ref='detalhesFormando'
            selecionado={this.state.selecionado}
            atualizarContrato={(data) => this.atualizarContrato(data)}
          />
          <DetalhesDistribuicao
            ref='detalhesDistribuicao'
            selecionado={this.state.selecionado}
            atualizarContrato={(data) => this.atualizarContrato(data)}
          />
          <DetalhesDistribuicaoOrcamentista
            ref='detalhesDistribuicaoOrcamentista'
            selecionado={this.state.selecionado}
            atualizarContrato={(data) => this.atualizarContrato(data)}
          />
          <DetalhesModuloPagamento
            ref='detalhesModuloPagamento'
            selecionado={this.state.selecionado}
            atualizarContrato={(data) => this.atualizarContrato(data)}
          />
          <Modal
            show={this.state.showModalLoginPersonalizadas}
            onHide={() => {
              this.setState({ showModalLoginPersonalizadas: false });
            }}
            dialogClassName='modal-80w'
          >
            <ModalLoginPersonalizadas
              contrato={this.state.selecionado}
              close={() =>
                this.setState({ showModalLoginPersonalizadas: false })
              }
            />
          </Modal>
          <Modal
            show={this.state.showModalNovo !== false}
            onHide={() => {
              this.setState({ showModalNovo: false });
            }}
            backdrop='static'
            dialogClassName='modal-90w'
          >
            <Modal.Header closeButton>
              <Modal.Title>
                Informações do contrato{' '}
                <span style={{ textDecoration: 'underline' }}>
                  {this.state.contrato.numero}
                </span>{' '}
                |
                {this.state.contrato.pagamentoIndividual === 'true' ? (
                  <span
                    style={{ marginLeft: 5, padding: '4px 10px' }}
                    className='badge alert-info'
                  >
                    Pagamento individual
                  </span>
                ) : null}
                {this.state.contrato.conviteOnline ? (
                  <span
                    style={{ marginLeft: 5, padding: '4px 10px' }}
                    className='badge alert-info'
                  >
                    Convite on-line
                  </span>
                ) : null}
                {this.state.contrato.sistemaPagto ? (
                  <span
                    style={{ marginLeft: 5, padding: '4px 10px' }}
                    className='badge alert-info'
                  >
                    Pagto. pelo sistema
                  </span>
                ) : null}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {this.state.abrindoContrato ? (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <i className='fa fa-spinner fa-spin fa-2x'></i>
                </div>
              ) : (
                this._renderFormContrato()
              )}
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
          </Modal>
          <Modal
            show={this.state.showModalItensKit}
            onHide={() => {
              this.setState({ showModalItensKit: false });
            }}
            dialogClassName='modal-50w'
          >
            <Modal.Header closeButton>
              <Modal.Title>Itens presentes no kit</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className='table-responsive'>
                <table className='table table-bordered table-striped'>
                  <thead>
                    <tr>
                      <th>Item</th>
                      <th>Quantidade</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.kitSelecionado
                      ? this.state.kitSelecionado.itens
                          .split(';')
                          .map((item, i) => {
                            let nome = item.split(' '),
                              qtd = item.split(' ')[0];
                            nome.splice(0, 2);
                            nome = nome.join(' ');
                            if (item) {
                              return (
                                <tr key={i}>
                                  <td>{nome}</td>
                                  <td>
                                    {this.state.kitSelecionado.quantidade * qtd}
                                  </td>
                                </tr>
                              );
                            }
                          })
                      : null}
                  </tbody>
                </table>
              </div>
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
          </Modal>
          <Modal
            show={this.state.modalCorrecao.show}
            onHide={() => {
              this.setState({
                modalCorrecao: { ...this.state.modalCorrecao, show: false },
              });
            }}
            backdrop='static'
            dialogClassName='modal-50w'
          >
            <Modal.Header closeButton>
              <Modal.Title>{this.state.modalCorrecao.titulo}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form onSubmit={this.enviarEmail}>
                <div className='form-group'>
                  <label htmlFor='modalCorrecaoNome'>Nome</label>
                  <input
                    type='text'
                    name='nome'
                    id='modalCorrecaoNome'
                    className='form-control'
                    value={this.state.modalCorrecao.dadosAlteracao.nome}
                    disabled={
                      this.state.modalCorrecao.tipo === 'alterarDadosContato'
                    }
                    onChange={
                      this.state.modalCorrecao.tipo === 'alterarDadosContato'
                        ? null
                        : (e) =>
                            this.setState({
                              modalCorrecao: {
                                ...this.state.modalCorrecao,
                                dadosAlteracao: {
                                  ...this.state.modalCorrecao.dadosAlteracao,
                                  nome: e.target.value,
                                },
                              },
                            })
                    }
                  />
                </div>
                <div className='row'>
                  <div className='form-group col-sm-12 col-md-6'>
                    <label htmlFor='modalCorrecaoEmail'>E-mail</label>
                    <input
                      type='email'
                      name='email'
                      id='modalCorrecaoEmail'
                      className='form-control'
                      value={this.state.modalCorrecao.dadosAlteracao.email}
                      disabled={
                        this.state.modalCorrecao.tipo === 'alterarDadosContato'
                      }
                      onChange={
                        this.state.modalCorrecao.tipo === 'alterarDadosContato'
                          ? null
                          : (e) =>
                              this.setState({
                                modalCorrecao: {
                                  ...this.state.modalCorrecao,
                                  dadosAlteracao: {
                                    ...this.state.modalCorrecao.dadosAlteracao,
                                    email: e.target.value,
                                  },
                                },
                              })
                      }
                    />
                  </div>
                  <div className='form-group col-sm-12 col-md-6'>
                    <label htmlFor='modalCorrecaoTelefone'>Telefone 1</label>
                    <input
                      type='text'
                      name='telefone'
                      id='modalCorrecaoTelefone'
                      className='form-control'
                      value={this.state.modalCorrecao.dadosAlteracao.telefone}
                      disabled={
                        this.state.modalCorrecao.tipo === 'alterarDadosContato'
                      }
                      onChange={
                        this.state.modalCorrecao.tipo === 'alterarDadosContato'
                          ? null
                          : (e) =>
                              this.setState({
                                modalCorrecao: {
                                  ...this.state.modalCorrecao,
                                  dadosAlteracao: {
                                    ...this.state.modalCorrecao.dadosAlteracao,
                                    telefone: e.target.value,
                                  },
                                },
                              })
                      }
                    />
                  </div>
                  <div className='form-group col-sm-12 col-md-6'>
                    <label htmlFor='modalCorrecaoOutroTelefone'>
                      Telefone 2
                    </label>
                    <input
                      type='text'
                      name='telefone'
                      id='modalCorrecaoOutroTelefone'
                      className='form-control'
                      value={
                        this.state.modalCorrecao.dadosAlteracao.outroTelefone
                      }
                      disabled={
                        this.state.modalCorrecao.tipo === 'alterarDadosContato'
                      }
                      onChange={
                        this.state.modalCorrecao.tipo === 'alterarDadosContato'
                          ? null
                          : (e) =>
                              this.setState({
                                modalCorrecao: {
                                  ...this.state.modalCorrecao,
                                  dadosAlteracao: {
                                    ...this.state.modalCorrecao.dadosAlteracao,
                                    outroTelefone: e.target.value,
                                  },
                                },
                              })
                      }
                    />
                  </div>
                </div>
                {this.state.modalCorrecao.tipo === 'alterarDadosContato' ? (
                  <div className='form-group'>
                    <label htmlFor='inputCorrecao'>
                      Digite abaixo as alterações necessárias
                    </label>
                    <textarea
                      id='inputCorrecao'
                      className='form-control'
                      rows={6}
                      placeholder={`Exemplo:\n\nAlterar nome para João Ninguém\nAlterar e-mail para joao@ninguem.com\nAlterar telefone 1 para (43) 9 9191 9292\nAlterar telefone 2 para (43) 9 8181 8282`}
                      onChange={(e) =>
                        this.setState({
                          modalCorrecao: {
                            ...this.state.modalCorrecao,
                            inputCorrecao: e.target.value,
                          },
                        })
                      }
                    ></textarea>
                  </div>
                ) : null}
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginTop: 15,
                  }}
                >
                  <button
                    type='submit'
                    className='btn btn-success btn-flat'
                    disabled={this.state.modalCorrecao.carregando}
                  >
                    {this.state.modalCorrecao.carregando ? (
                      <span>
                        <i className='fa fa-spinner fa-pulse' /> Aguarde
                      </span>
                    ) : (
                      'Salvar'
                    )}
                  </button>
                </div>
              </form>
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
          </Modal>
          <Modal
            show={this.state.confirmarCancelamentoContrato}
            onHide={() => {
              this.setState({ confirmarCancelamentoContrato: false });
            }}
          >
            <Modal.Header closeButton>
              <Modal.Title>Cancelar contrato</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Você tem certeza que quer cancelar o contrato{' '}
              {this.state.contrato.numero}?
            </Modal.Body>
            <Modal.Footer>
              <button
                onClick={() => {
                  this.setState({ confirmarCancelamentoContrato: false });
                }}
                disabled={this.state.cancelandoContrato}
                className='btn btn-link btn-flat'
              >
                Cancelar
              </button>
              <button
                onClick={this.cancelarContrato.bind(this)}
                disabled={this.state.cancelandoContrato}
                className='btn btn-danger btn-flat'
              >
                {this.state.cancelandoContrato ? (
                  <span>
                    <i className='fa fa-spinner fa-spin'></i> Deletando
                  </span>
                ) : (
                  'Cancelar contrato'
                )}
              </button>
            </Modal.Footer>
          </Modal>
        </section>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: {
      autenticado: state.usuario.autenticado,
      todos: state.usuario.todos,
    },
    contrato: state.contrato.ultimo,
    todos: state.contrato.todos,
    contratosNovos: state.contrato.cadastrados,
    confirmarPlanilha: state.contrato.confirmarPlanilha,
  };
};

export default connect(mapStateToProps, {
  editarContrato,
  obterContratoLikePeloNumero,
  editarUsuario,
  atualizarStatusLiberacaoPlanilha,
  liberarPlanilhaQuantidades,
  estornarPlanilhaQuantidades,
  cancelarContrato,
  setStatusDistBrindes,
  setStatusEnderecoPreenchido,
  setStatusPersonalizacaoLiberada,
  setStatusWeblojaLiberada,
})(ContratosTodos);



// WEBPACK FOOTER //
// ./src/views/ContratosTodos.js